import api from './clients';
import type { Gasto, CreateGastoDto, GastoStats } from '../types/gasto';

interface GetAllGastosParams {
  search?: string;
  categoria?: string;
  fechaInicio?: string;
  fechaFin?: string;
  page?: number;
  limit?: number;
}

export const gastosApi = {
  getAll: async (params?: GetAllGastosParams): Promise<any> => {
    const response = await api.get('/gastos', { params });
    return response.data;
  },

  getById: async (id: number): Promise<Gasto> => {
    const response = await api.get(`/gastos/${id}`);
    return response.data.data;
  },

  create: async (data: CreateGastoDto): Promise<Gasto> => {
    const response = await api.post('/gastos', data);
    return response.data.data;
  },

  update: async (id: number, data: Partial<CreateGastoDto>): Promise<Gasto> => {
    const response = await api.put(`/gastos/${id}`, data);
    return response.data.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/gastos/${id}`);
  },

  getStats: async (): Promise<GastoStats> => {
    const response = await api.get('/gastos/estadisticas');
    return response.data.data;
  },

  getMensuales: async (meses: number = 6): Promise<Array<{ mes: string; gastos: number }>> => {
    const response = await api.get('/gastos/mensuales', { params: { meses } });
    return response.data.data;
  },

  getDistribucion: async (meses: number = 1): Promise<Array<{ categoria: string; monto: number }>> => {
    const response = await api.get('/gastos/distribucion', { params: { meses } });
    return response.data.data;
  },
};